var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import supercluster from "supercluster";
import { getCardinalBoundsFromInterCardinalBounds } from "./geometry";
/**
 * Transforms a regular data item into a GeoJSON Feature object which is the format required
 * by the supercluster library
 *
 * @param {Object} item A data Item that must contain lat and lng keys, anything else will be returned
 *  with the same key names as part of the GeoJSON Feature object
 *
 * @returns Object
 */
var transformDataItemToGeoJSONFeature = function (item) {
    var lat = item.lat, lng = item.lng;
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: [lng, lat]
        },
        properties: __assign({}, item)
    };
};
/**
 * Provides a hash table with the zoom level required for any items that are within a cluster.
 * The property `key` for each item is used as the hash table key.
 *
 * @param {Object} superclusterIndex The index from the supercluster package used to generate the cluster data
 * @param {Array} clusters The cluster data to work with
 * @param {Integer} clusterMaxZoom The maximum zoom level used in the clustering
 *
 * @readonly Object The generated Hash Table
 */
var generateClusterZoomHashTable = function (superclusterIndex, clusters, clusterMaxZoom) {
    var hash = {};
    clusters.map(function (item) {
        var cluster_id = item.properties.cluster_id;
        if (cluster_id) {
            superclusterIndex.getLeaves(cluster_id, Infinity).map(function (leaf) {
                var key = leaf.properties.key;
                hash[key] = clusterMaxZoom + 1;
            });
        }
    });
    return hash;
};
/**
 * Generates cluster data to use for rendering clusters on a map
 *
 * @param {DataItem[]} data The raw data to generate from
 * @param {number} mapZoom The current zoom level of the map
 * @param {InterCardinalBounds} mapBounds The map bounds in intermediate direction format
 * @param {number} clusterMinZoom Minimum zoom level at which clusters are generated
 * @param {number} clusterMaxZoom Maximum zoom level at which clusters are generated
 * @param {number} clusterRadius The cluster radius, in pixels
 *
 * @returns {Object} The cluster data
 */
export var generateClusterData = function (data, mapZoom, mapBounds, clusterMinZoom, clusterMaxZoom, clusterRadius) {
    var minZoom = Math.min(clusterMinZoom, clusterMaxZoom);
    var index = supercluster({
        radius: clusterRadius,
        minZoom: minZoom,
        maxZoom: clusterMaxZoom
    });
    var points = data.map(function (item) { return transformDataItemToGeoJSONFeature(item); });
    index.load(points);
    var _a = getCardinalBoundsFromInterCardinalBounds(mapBounds), n = _a.n, e = _a.e, s = _a.s, w = _a.w;
    var clusters = index.getClusters([w.lng, s.lat, e.lng, n.lat], mapZoom);
    var zoomHash = generateClusterZoomHashTable(index, clusters, clusterMaxZoom);
    return {
        clusters: clusters,
        zoomHash: zoomHash
    };
};
